import { getCsrfToken } from "@/lib/csrf"
import { getJson } from "@/lib/fetch-json"

// Fetch and update deal assignment (owners). Mirrors
// `contact-assignment-api.ts` 1:1 — GET returns camelCase
// JSON already, PATCH sends the snake_case form key the
// Rails controller expects. Callers check
// `res.status === 204` for success.

// One teammate option from `V2::Deals::AssigneesPresenter`
// (already camelCase). Same shape as the contacts presenter
// but with `dealsCount` (open deals per employee).
export interface DealAssigneePickerRow {
  id: number
  name: string
  initials: string
  color: string
  role: string
  dealsCount: number
  email: string
}

export interface DealAssigneesPickerData {
  employees: DealAssigneePickerRow[]
}

// GET /v2/deals/assignees?q=<query>
// Returns the full employee list when q is empty; filtered
// when q is non-empty.
export async function fetchDealAssignees(
  q: string,
  signal?: AbortSignal,
): Promise<DealAssigneesPickerData> {
  const params = new URLSearchParams()
  if (q) params.set("q", q)
  return getJson<DealAssigneesPickerData>(
    `/v2/deals/assignees?${params.toString()}`,
    signal,
  )
}

// PATCH /v2/deals/:dealId/assignment
// Body: { v2_deals_assignments_update_form: { employee_ids: number[] } }
// Returns a raw Response so the caller can check status
// (204 = success, 422 = validation errors).
export function updateDealAssignment(
  dealId: number,
  employeeIds: number[],
): Promise<Response> {
  return fetch(`/v2/deals/${dealId}/assignment`, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Token": getCsrfToken(),
    },
    credentials: "same-origin",
    body: JSON.stringify({
      v2_deals_assignments_update_form: {
        employee_ids: employeeIds,
      },
    }),
  })
}
